export default __webpack_public_path__ + "static/media/Roboto-BlackItalic.34e29731.ttf";